// extracted by mini-css-extract-plugin
module.exports = {"outer":"TVLChart_outer__3p7Wf","container":"TVLChart_container__3yAFt","wrap":"TVLChart_wrap__2_0yE","header":"TVLChart_header__10yH1","legend":"TVLChart_legend__3xzR9"};